import React, { useState, useRef, useContext, useEffect } from "react";
import { SearchOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import { Form as FormR } from "react-bootstrap";
import { Button } from "react-bootstrap";
import { Table, Form, Input } from "antd";
import AxiosHelper from "../../../helper/axios-helper";
import { toast, ToastContainer } from "react-toastify";
import NavBar from "../../NavBar/navbar";
import { useNavigate } from "react-router-dom";
import { canAccessPage, getTokenUser } from "../../../helper/token";
import VendorContacts from "./VendorContacts";
import SharedModal from "../Shared/SharedModal";

const VendorList = () => {
  const [filters, setFilters] = useState({
    VendorName: [],
    VendorStatus: [
      {
        text: "Active",
        value: "Active",
      },
      {
        text: "Inactive",
        value: "Inactive",
      },
    ],
  });
  const [selectedFilters, SetSelectedFilters] = useState({
    VendorName: [],
    VendorStatus: ["Active"],
  });
  const [dropDownOptions, setDropDownOptions] = useState({
    VendorPaymentTerms: [],
    Users: [],
  });
  const [vendors, setVendors] = useState([]);
  const [vendorContacts, setVendorContacts] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState();
  const [isModalOpen, setIsModalOpen] = useState({
    VendorContacts: false,
    DeleteVendor: false,
  });
  const navigate = useNavigate();

  const tooltipColour = "#274D68";
  const EditableContext = React.createContext(null);

  const getNewVendorId = () => {
    let largestId = 0;
    vendors.forEach((vendor) => {
      if (vendor.VendorId > largestId) {
        largestId = vendor.VendorId;
      }
    });

    return largestId + 1;
  };

  const populateUI = () => {
    AxiosHelper.makeAxiosRequest("Read", "Vendor", "GetVendors", null, null)
      .then((response) => {
        const data = response.data;
        const vendorNames = [];
        if (data != null && data.length > 0) {
          data.forEach((vendor, i) => {
            vendor.key = i;
            vendor.VendorType = "Server";
            vendor.VendorContactDetail = [];
            vendorNames.push({
              text: vendor.VendorName,
              value: vendor.VendorName,
            });
          });
          setFilters((prevState) => ({
            ...prevState,
            VendorName: vendorNames,
          }));
          setVendors(data);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    AxiosHelper.makeAxiosRequest("Read", "User", "GetUsers", null, null)
      .then((response) => {
        const users = response.data;
        const activeUsers = [{ id: -1, name: "" }];

        users.forEach((user) => {
          if (user.active) {
            activeUsers.push({
              id: user.userId,
              name: user.firstName + " " + user.surname,
            });
          }
        });

        setDropDownOptions((prevState) => ({
          ...prevState,
          Users: activeUsers,
        }));
      })
      .catch((error) => {
        console.log(error);
      });

    AxiosHelper.makeAxiosRequest(
      "Read",
      "Customer",
      "GetPaymentTerm",
      null,
      null
    )
      .then((response) => {
        setDropDownOptions((prevState) => ({
          ...prevState,
          VendorPaymentTerms: response.data,
        }));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  React.useEffect(() => {
    if (!canAccessPage("Vendor")) {
      navigate("/login");
    }
    populateUI();
  }, [navigate]);

  const EditableRow = ({ index, ...props }) => {
    const [form] = Form.useForm();
    return (
      <Form form={form} component={false}>
        <EditableContext.Provider value={form}>
          <tr {...props} />
        </EditableContext.Provider>
      </Form>
    );
  };

  const EditableCell = ({
    title,
    editable,
    children,
    dataIndex,
    record,
    handleSave,
    ...restProps
  }) => {
    const [editing, setEditing] = useState(false);
    const inputRef = useRef(null);
    const form = useContext(EditableContext);
    useEffect(() => {
      if (editing) {
        inputRef.current.focus();
      }
    }, [editing]);
    const toggleEdit = () => {
      setEditing(!editing);
      form.setFieldsValue({
        [dataIndex]: record[dataIndex],
      });
    };
    const save = async () => {
      try {
        const values = await form.validateFields();
        toggleEdit();
        handleSave({
          ...record,
          ...values,
        });
      } catch (errInfo) {
        console.log("Save failed:", errInfo);
      }
    };
    let childNode = children;
    if (editable) {
      childNode = editing ? (
        <Form.Item
          style={{
            margin: 0,
          }}
          name={dataIndex}
          rules={[
            {
              required: true,
              message: `${title} is required.`,
            },
          ]}
        >
          <Input ref={inputRef} onPressEnter={save} onBlur={save} />
        </Form.Item>
      ) : (
        <div
          className="editable-cell-value-wrap"
          style={{
            paddingRight: 24,
          }}
          onClick={toggleEdit}
        >
          {children}
        </div>
      );
    }
    return <td {...restProps}>{childNode}</td>;
  };

  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  const handleChange = (e, row, key) => {
    notifyChanges("The table contains unsaved changes.");
    row[key] = e.target.value;

    const newData = [...vendors];
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row,
    });
    setVendors(newData);
  };

  const handleAddVendor = () => {
    notifyChanges("The table contains unsaved changes.");
    const newData = {
      key: getNewVendorId(),
      VendorId: getNewVendorId(),
      VendorName: "",
      VendorRegNo: "",
      VendorAddress: "",
      VendorVatNo: "",
      VendorEmail: "",
      UserId: -1,
      UserName: "",
      VendorPaymentTermId: 1,
      VendorStatus: "Active",
      VendorType: "Client",
      VendorContactDetail: [],
    };
    setVendors([...vendors, newData]);
  };

  const vendorColumns = [
    {
      title: "Id",
      dataIndex: "VendorId",
      render: (text, record, index) => {
        return (
          <div style={{ minWidth: "15px" }}>
            <p>{text}</p>
          </div>
        );
      },
    },
    {
      title: "Vendor Name",
      dataIndex: "VendorName",
      filters: filters.VendorName,
      filterSearch: true,
      filteredValue: selectedFilters.VendorName,
      onFilter: (value, record) => record.VendorName.startsWith(value),
      filterIcon: (filtered) => (
        <SearchOutlined
          style={{ color: filtered ? "blue" : "#000000", fontSize: "16px" }}
        />
      ),
      render: (text, record, index) => {
        let isValid = true;

        if (record.VendorName === "-" || record.VendorName === "") {
          isValid = false;
        }

        //testing duplicate names
        if (
          vendors.filter(
            (tableVendor) => tableVendor.VendorName === record.VendorName
          ).length > 1
        ) {
          isValid = false;
        }

        return (
          <div
            style={{
              minWidth: "150px",
              display: "flex",
              position: "relative",
            }}
          >
            {!isValid && (
              <Tooltip
                title="Verndor name should be unique, and can't be empty or '-'."
                color="#f88d8d"
              >
                <p className={"exclamation"}>!</p>
              </Tooltip>
            )}
            <FormR.Control
              className={`editable-cell-input ${
                !isValid ? "invalid-cell" : ""
              }`}
              size="sm"
              type="text"
              defaultValue={record.VendorName}
              onBlur={(e) => handleChange(e, record, "VendorName")}
            ></FormR.Control>
          </div>
        );
      },
    },
    {
      title: "Registration Number",
      dataIndex: "VendorRegNo",
      render: (text, record, index) => {
        let isValid = true;

        if (record.VendorRegNo === "-" || record.VendorRegNo === "") {
          isValid = false;
        }

        return (
          <div
            style={{
              minWidth: "150px",
              display: "flex",
              position: "relative",
            }}
          >
            {!isValid && (
              <Tooltip
                title="Registration number can't be empty or '-'."
                color="#f88d8d"
              >
                <p className={"exclamation"}>!</p>
              </Tooltip>
            )}
            <FormR.Control
              className={`editable-cell-input ${
                !isValid ? "invalid-cell" : ""
              }`}
              size="sm"
              type="text"
              defaultValue={record.VendorRegNo}
              onBlur={(e) => handleChange(e, record, "VendorRegNo")}
            ></FormR.Control>
          </div>
        );
      },
    },
    {
      title: "Address",
      dataIndex: "VendorAddress",
      render: (text, record, index) => {
        let isValid = true;

        if (record.VendorAddress === "-" || record.VendorAddress === "") {
          isValid = false;
        }

        return (
          <div
            style={{
              minWidth: "150px",
              display: "flex",
              position: "relative",
            }}
          >
            {!isValid && (
              <Tooltip
                title="Vendor address can't be empty or '-'."
                color="#f88d8d"
              >
                <p className={"exclamation"}>!</p>
              </Tooltip>
            )}
            <FormR.Control
              className={`editable-cell-input ${
                !isValid ? "invalid-cell" : ""
              }`}
              size="sm"
              type="text"
              defaultValue={record.VendorAddress}
              onBlur={(e) => handleChange(e, record, "VendorAddress")}
            ></FormR.Control>
          </div>
        );
      },
    },
    {
      title: "Vat Number",
      dataIndex: "VendorVatNo",
      render: (text, record, index) => {
        let isValid = true;

        if (record.VendorVatNo === "-" || record.VendorVatNo === "") {
          isValid = false;
        }

        return (
          <div
            style={{
              minWidth: "150px",
              display: "flex",
              position: "relative",
            }}
          >
            {!isValid && (
              <Tooltip
                title="Vat number can't be empty or '-'."
                color="#f88d8d"
              >
                <p className={"exclamation"}>!</p>
              </Tooltip>
            )}

            <FormR.Control
              className={`editable-cell-input ${
                !isValid ? "invalid-cell" : ""
              }`}
              size="sm"
              type="text"
              defaultValue={record.VendorVatNo}
              onBlur={(e) => handleChange(e, record, "VendorVatNo")}
            ></FormR.Control>
          </div>
        );
      },
    },
    {
      title: "Email Address",
      dataIndex: "VendorEmail",
      render: (text, record, index) => {
        let isValid = true;

        if (record.VendorEmail === "-" || record.VendorEmail === "") {
          isValid = false;
        }

        if (
          !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
            record.VendorEmail
          )
        ) {
          isValid = false;
        }

        return (
          <div
            style={{
              minWidth: "150px",
              display: "flex",
              position: "relative",
            }}
          >
            {!isValid && (
              <Tooltip
                title="Vendor email should be valid, and can't be empty or '-'."
                color="#f88d8d"
              >
                <p className={"exclamation"}>!</p>
              </Tooltip>
            )}
            <FormR.Control
              className={`editable-cell-input ${
                !isValid ? "invalid-cell" : ""
              }`}
              size="sm"
              type="text"
              defaultValue={record.VendorEmail}
              onBlur={(e) => handleChange(e, record, "VendorEmail")}
            ></FormR.Control>
          </div>
        );
      },
    },
    {
      title: "Account Manager",
      dataIndex: "UserId",
      render: (text, record, index) => {
        let isValid = true;
        if (
          record.UserId === -1 ||
          record.UserName === "-" ||
          record.UserName === ""
        ) {
          isValid = false;
        }

        return (
          <div
            className="dropdown"
            style={{ width: "130px", display: "flex", position: "relative" }}
          >
            {!isValid && (
              <Tooltip
                title="Please select an account manager. Can't be empty or '-'."
                color="#f88d8d"
              >
                <p className={"exclamation"}>!</p>
              </Tooltip>
            )}
            <Tooltip title={record.UserName} color={tooltipColour}>
              <FormR.Select
                size="sm"
                defaultValue={record.UserId}
                onChange={(e) => {
                  handleChange(e, record, "UserId");
                  handleChange(e, record, "UserName");
                }}
                className={`${!isValid ? "invalid-cell" : ""}`}
              >
                {dropDownOptions.Users.map((x) => (
                  <option value={x.id}>{x.name}</option>
                ))}
              </FormR.Select>
            </Tooltip>
          </div>
        );
      },
    },
    {
      title: "Contact(s)",
      render: (text, record, index) => (
        <div>
          <Button
            size="sm"
            variant="primary"
            onClick={() => handleVendorContacts(record, index)}
          >
            Manage
          </Button>
        </div>
      ),
    },
    {
      title: "Payment Terms",
      dataIndex: "VendorPaymentTermId",
      render: (text, record, index) => (
        <div className="dropdown" style={{ width: "105px" }}>
          <FormR.Select
            size="sm"
            defaultValue={record.VendorPaymentTermId}
            onChange={(e) => handleChange(e, record, "VendorPaymentTermId")}
          >
            {dropDownOptions.VendorPaymentTerms.map((x) => (
              <option value={x.PaymentTermId}>
                {x.PaymentTermDescription} days
              </option>
            ))}
          </FormR.Select>
        </div>
      ),
    },
    {
      title: "Status",
      dataIndex: "VendorStatus",
      filters: filters.VendorStatus,
      filterSearch: true,
      filteredValue: selectedFilters.VendorStatus,
      onFilter: (value, record) => record.VendorStatus.startsWith(value),
      filterIcon: (filtered) => (
        <SearchOutlined
          style={{ color: filtered ? "blue" : "#000000", fontSize: "16px" }}
        />
      ),
      render: (text, record, index) => (
        <div className="dropdown" style={{ width: "105px" }}>
          <FormR.Select
            size="sm"
            defaultValue={record.VendorStatus}
            onChange={(e) => handleChange(e, record, "VendorStatus")}
          >
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </FormR.Select>
        </div>
      ),
    },
    {
      title: "Actions",
      render: (text, record, index) => (
        <img
          className="delete-icon"
          src={require("../../CustomerListView/delete.png")}
          alt="Not Found!"
          onClick={() => handleOpenDeleteModal(record)}
        />
      ),
    },
  ];

  const handleOpenDeleteModal = (vendor) => {
    setSelectedVendor(vendor);
    handleOpenModal("DeleteVendor");
  };

  const handleVendorDelete = (record) => {
    const data = vendors.filter((vendor) => vendor.key !== record.key);
    setVendors(data);
    if (record.VendorType === "Server") {
      AxiosHelper.makeAxiosRequest(
        "Delete",
        "Vendor",
        "DeleteVendor",
        { currentUserId: getTokenUser(), vendorId: record.VendorId },
        null
      )
        .then(() => {
          notifySuccessful("Vendor deleted successfully");
        })
        .catch((error) => {
          console.log(error);
          notifyFailed("Failed to delete vendor");
        });
    }
  };

  const handleVendorContacts = (record, index) => {
    if (
      vendors[index].VendorContactDetail.length === 0 &&
      vendors[index].VendorType === "Server"
    ) {
      AxiosHelper.makeAxiosRequest(
        "Read",
        "Vendor",
        "GetVendorContact",
        { VendorId: vendors[index].VendorId },
        null
      )
        .then((response) => {
          setVendors((prevState) => {
            const updatedVendors = [...prevState];
            updatedVendors[index].VendorContactDetail = response.data.map(
              (contact, i) => ({
                VendorContactDeleted: contact.vendorContactDeleted,
                VendorContactEmail: contact.vendorContactEmail,
                VendorContactMobile: contact.vendorContactMobile,
                VendorContactId: contact.vendorContactId,
                VendorContactName: contact.vendorContactName,
                key: i.toString(),
                VendorContactType: "Server",
              })
            );
            return updatedVendors;
          });
          setIsModalOpen((prevState) => ({
            ...prevState,
            VendorContacts: true,
          }));
          setVendorContacts(vendors[index]);
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setIsModalOpen((prevState) => ({
        ...prevState,
        VendorContacts: true,
      }));
      setVendorContacts(vendors[index]);
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    SetSelectedFilters(filters);
  };

  const notifySuccessful = (message) => {
    toast.dismiss();
    toast.success(message, {
      position: "bottom-center",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const notifyFailed = (message) => {
    toast.dismiss();
    toast.error(message, {
      position: "bottom-center",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const notifyChanges = (message) => {
    toast.warning(message, {
      toastId: "ToastDataTableWarning",
      position: "top-right",
      autoClose: false,
      closeOnClick: true,
      draggable: false,
      progress: undefined,
      closeButton: true,
    });
  };

  const isValid = () => {
    let valid = true;
    vendors.forEach((vendor) => {
      if (
        vendor.VendorName === "" ||
        vendor.VendorName === "-" ||
        vendor.VendorRegNo === "" ||
        vendor.VendorRegNo === "-" ||
        vendor.VendorAddress === "" ||
        vendor.VendorAddress === "-" ||
        vendor.VendorVatNo === "" ||
        vendor.VendorVatNo === "-" ||
        vendor.VendorEmail === "" ||
        vendor.VendorEmail === "-" ||
        !/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
          vendor.VendorEmail
        ) ||
        vendor.UserId === -1 ||
        vendor.UserName === "" ||
        vendor.UserName === "-" ||
        vendor.PaymentTermId === 0
      ) {
        valid = false;
      }
    });
    return valid;
  };

  const handleCloseModal = (modal) => {
    setIsModalOpen((prevState) => ({
      ...prevState,
      [modal]: false,
    }));
  };

  const handleOpenModal = (modal) => {
    setIsModalOpen((prevState) => ({
      ...prevState,
      [modal]: true,
    }));
  };

  const handleSaveContactsDetails = (vendorId, vendorContacts) => {
    vendorContacts.forEach((contact) => {
      if (contact.VendorContactType === "Client") {
        AxiosHelper.makeAxiosRequest(
          "Create",
          "Vendor",
          "CreateVendorContact",
          { currentUserId: getTokenUser() },
          {
            VendorContactId: 0,
            VendorId: vendorId,
            VendorContactName: contact.VendorContactName,
            VendorContactMobile: contact.VendorContactMobile,
            VendorContactEmail: contact.VendorContactEmail,
            VendorContactType: contact.VendorContactType,
          }
        )
          .then((response) => {
            const updatedContacts = [...vendorContacts];

            const contactIndex = updatedContacts.findIndex(
              (c) => c.key === contact.key
            );
            updatedContacts[contactIndex].VendorContactId = response.data;
            updatedContacts[contactIndex].VendorContactType = "Server";
            setVendors((prevState) => {
              const updatedVendors = [...prevState];
              const index = updatedVendors.findIndex(
                (vendor) => vendor.VendorId === vendorId
              );
              updatedVendors[index].VendorContactDetail = updatedContacts;
              return updatedVendors;
            });
          })
          .catch((error) => {
            console.log(error);
            notifyFailed("Failed to add contacts");
          });
      } else {
        AxiosHelper.makeAxiosRequest(
          "Create",
          "Vendor",
          "UpdateVendorContact",
          { currentUserId: getTokenUser() },
          {
            VendorContactId: contact.VendorContactId,
            VendorId: vendorId,
            VendorContactName: contact.VendorContactName,
            VendorContactMobile: contact.VendorContactMobile,
            VendorContactEmail: contact.VendorContactEmail,
            VendorContactType: contact.VendorContactType,
          }
        )
          .then((response) => {
            notifySuccessful("Contacts updated successfully");
            setVendors((prevState) => {
              const updatedVendors = [...prevState];
              const index = updatedVendors.findIndex(
                (vendor) => vendor.VendorId === vendorId
              );
              updatedVendors[index].VendorContactDetail.VendorContactId =
                response.data;
              return updatedVendors;
            });
          })
          .catch((error) => {
            console.log(error);
            notifyFailed("Failed to update contacts");
          });
      }
    });
  };

  const handleSave = () => {
    if (isValid()) {
      vendors.forEach((vendor, index) => {
        if (vendor.VendorType === "Client") {
          const vendorSave = {
            VendorId: 0,
            VendorName: vendor.VendorName,
            VendorRegNo: vendor.VendorRegNo,
            VendorAddress: vendor.VendorAddress,
            VendorVatNo: vendor.VendorVatNo,
            VendorEmail: vendor.VendorEmail,
            UserId: Number(vendor.UserId),
            VendorPaymentTermId: Number(vendor.VendorPaymentTermId),
            VendorStatus: vendor.VendorStatus,
            VendorDeleted: false,
          };

          AxiosHelper.makeAxiosRequest(
            "Create",
            "Vendor",
            "CreateNewVendor",
            { currentUserId: getTokenUser() },
            vendorSave
          )
            .then((response) => {
              const updatedVendors = [...vendors];
              updatedVendors[index].VendorId = response.data;
              updatedVendors[index].VendorType = "Server";
              setVendors(updatedVendors);
              handleSaveContactsDetails(
                response.data,
                vendor.VendorContactDetail
              );
              notifySuccessful("Vendors added successfully");
            })
            .catch((error) => {
              notifyFailed("Failed to add vendors");
            });
        } else {
          const vendorSave = {
            VendorId: vendor.VendorId,
            VendorName: vendor.VendorName,
            VendorRegNo: vendor.VendorRegNo,
            VendorAddress: vendor.VendorAddress,
            VendorVatNo: vendor.VendorVatNo,
            VendorEmail: vendor.VendorEmail,
            UserId: Number(vendor.UserId),
            VendorPaymentTermId: Number(vendor.VendorPaymentTermId),
            VendorStatus: vendor.VendorStatus,
            VendorDeleted: false,
          };
          AxiosHelper.makeAxiosRequest(
            "Create",
            "Vendor",
            "UpdateVendor",
            { currentUserId: getTokenUser() },
            vendorSave
          )
            .then((response) => {
              notifySuccessful("Vendors updated successfully");
              handleSaveContactsDetails(
                vendor.VendorId,
                vendor.VendorContactDetail
              );
            })
            .catch((error) => {
              console.log(error);
              notifyFailed("Failed to update vendors");
            });
        }
      });
    } else {
      notifyFailed("Please fill in all the fields correctly");
    }
  };

  const handleAddContacts = () => {
    notifyChanges("The table contains unsaved changes.");
    setVendorContacts((prevState) => ({
      ...prevState,
      VendorContactDetail: [
        ...prevState.VendorContactDetail,
        {
          key: prevState.VendorContactDetail.length + 1,
          VendorContactId: 0,
          VendorId: prevState.VendorId,
          VendorContactName: "",
          VendorContactMobile: "",
          VendorContactEmail: "",
          VendorContactType: "Client",
        },
      ],
    }));
  };

  const handleUpdateContacts = (e, record, key) => {
    notifyChanges("The table contains unsaved changes.");
    const updatedContacts = [...vendorContacts.VendorContactDetail];
    const index = updatedContacts.findIndex((item) => record.key === item.key);
    const item = updatedContacts[index];
    updatedContacts.splice(index, 1, {
      ...item,
      [key]: e.target.value,
    });
    setVendorContacts((prevState) => ({
      ...prevState,
      VendorContactDetail: updatedContacts,
    }));
  };

  const handleDeleteContacts = (record) => {
    console.log(record);
    if (record.VendorContactType === "Server") {
      AxiosHelper.makeAxiosRequest(
        "Delete",
        "Vendor",
        "DeleteVendorContact",
        { currUserId: getTokenUser(), vendorContactId: record.VendorContactId },
        null
      )
        .then(() => {
          notifySuccessful("Contact deleted successfully");
        })
        .catch((error) => {
          console.log(error);
          notifyFailed("Failed to delete contact");
        });
    }
    const updatedContacts = vendorContacts.VendorContactDetail.filter(
      (contact) => contact.key !== record.key
    );
    setVendorContacts((prevState) => ({
      ...prevState,
      VendorContactDetail: updatedContacts,
    }));
    notifyChanges("The table contains unsaved changes.");
  };

  const handleSaveContacts = () => {
    setVendors((prevState) => {
      const updatedVendors = [...prevState];
      const index = updatedVendors.findIndex(
        (vendor) => vendor.VendorId === vendorContacts.VendorId
      );
      updatedVendors[index].VendorContactDetail =
        vendorContacts.VendorContactDetail;
      return updatedVendors;
    });
    setIsModalOpen({ VendorContacts: false });
    notifyChanges("The table contains unsaved changes.");
  };

  const handleClearContacts = (clearVendor) => {
    if (clearVendor.VendorType === "Server") {
      AxiosHelper.makeAxiosRequest(
        "Read",
        "Vendor",
        "GetVendorContact",
        { VendorId: clearVendor.VendorId },
        null
      )
        .then((response) => {
          setVendors((prevState) => {
            const updatedVendors = [...prevState];
            const index = updatedVendors.findIndex(
              (vendor) => vendor.VendorId === clearVendor.VendorId
            );
            updatedVendors[index].VendorContactDetail = response.data.map(
              (contact, i) => ({
                VendorContactDeleted: contact.vendorContactDeleted,
                VendorContactEmail: contact.vendorContactEmail,
                VendorContactMobile: contact.vendorContactMobile,
                VendorContactId: contact.vendorContactId,
                VendorContactName: contact.vendorContactName,
                key: i.toString(),
                VendorContactType: "Server",
              })
            );
            return updatedVendors;
          });
          setVendorContacts((prevState) => ({
            ...prevState,
            VendorContactDetail: response.data.map((contact, i) => ({
              VendorContactDeleted: contact.vendorContactDeleted,
              VendorContactEmail: contact.vendorContactEmail,
              VendorContactMobile: contact.vendorContactMobile,
              VendorContactId: contact.vendorContactId,
              VendorContactName: contact.vendorContactName,
              key: i.toString(),
              VendorContactType: "Server",
            })),
          }));
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      setVendorContacts((prevState) => ({
        ...prevState,
        VendorContactDetail: [],
      }));
    }
  };

  return (
    <>
      <ToastContainer />
      <NavBar />

      <VendorContacts
        vendor={vendorContacts}
        isOpen={isModalOpen.VendorContacts}
        handleUpdateContacts={(e, record, key) => {
          handleUpdateContacts(e, record, key);
        }}
        handleAddContacts={handleAddContacts}
        handleDeleteContacts={(e, record, key) =>
          handleDeleteContacts(e, record, key)
        }
        handleClose={() => {
          handleCloseModal("VendorContacts");
        }}
        handleSaveContacts={handleSaveContacts}
        handleClearContacts={handleClearContacts}
      />

      <SharedModal
        isOpen={isModalOpen.DeleteVendor}
        title={"Delete Vendor"}
        onDelete={() => {
          handleVendorDelete(selectedVendor);
        }}
        onClose={() => {
          handleCloseModal("DeleteVendor");
        }}
      >
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div>
            <p className="p-main">
              Are you sure you want to delete the following Vendor?
              <br />
              This change can not be reversed.
            </p>
          </div>
          <div>
            <p className="p-main">{selectedVendor?.VendorName}</p>
          </div>
        </div>
      </SharedModal>

      <div id="listview-body">
        <h1>Vendors</h1>
        <div className="col-12">
          <div id="home-table-container">
            <Table
              id="home-table"
              pagination={{
                position: ["bottomCenter"],
                showSizeChanger: true,
                defaultPageSize: 100,
                hideOnSinglePage: true,
                pageSizeOptions: [5, 10, 20, 50, 100],
              }}
              onChange={handleTableChange}
              bordered="true"
              components={components}
              columns={vendorColumns}
              dataSource={vendors}
              rowClassName="row-class-test"
              footer={() => (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div>
                    <Button onClick={handleAddVendor}>Add</Button>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "right",
                      gap: "20px",
                    }}
                  >
                    <Button variant="danger" onClick={populateUI}>
                      Clear Changes
                    </Button>
                    <Button onClick={handleSave} variant="success">
                      Save Changes
                    </Button>
                  </div>
                </div>
              )}
            ></Table>
          </div>
        </div>
      </div>
    </>
  );
};

export default VendorList;
